<template>
  <gh-table-page ref="table" :args-query="argsQuery" module="plat.page" cls="PageCodeService" :before-save="submitCode"
    @update:tableConfig="updateTableConfig">
    <template #area_query>
      <v-layout row align-center>

        <gh-input v-model="argsQuery.type" :prop="typeProp" @input="$refs.table.query()"></gh-input>
        <v-text-field v-model="argsQuery.keyword" counter :autofocus="true" clearable label="关键字"
          append-icon="mdi-circle-edit-outline" @change="$refs.table.query()">
        </v-text-field>
        <gh-menu ref="menu" :nudge-width="200" title="" :allow-submit="true" :closeOnClick="true" :showActions="false">
          <template #activator="{on}">
            <v-text-field v-model="menuName" label="功能" readonly v-on="on" clearable @click:clear="menuClear">
            </v-text-field>
          </template>

          <gh-business-tree ref="tree" module="plat.menu" cls="MenuService" :showToolbar="true" :accordion="true"
            :draggable="false" :expand-on-click-node="false" :default-expand-all="false" parent-id="parentId"
            props="props" @current-change="selectedMenu">
            <template v-slot="{node,data}">
              <div>
                <v-icon flat>{{data.icon}}</v-icon> {{data.Name}}
              </div>
            </template>
          </gh-business-tree>
        </gh-menu>
      </v-layout>

    </template>

    <template #area_edit="{model,props}">
      <v-container grid-list-xs fluid>
        <v-layout column>
          <v-layout row wrap align-center>
            <gh-input :model="model" :prop="getPropType(props,'Cd')"></gh-input>
            <gh-input :model="model" :prop="getPropType(props,'Type')"></gh-input>
            <gh-input :model="model" :prop="getPropType(props,'Name')"></gh-input>

          </v-layout>

          <v-tabs color="primary" dark slider-color="primary">

            <v-tab key="前台代码" ripple>
              前台代码
            </v-tab>
            <v-tab key="后台代码" ripple>
              后台代码
            </v-tab>
            <!-- <v-tab key="模板参数" ripple v-show="model.Type==='模板'">
              模板参数
            </v-tab> -->
            <v-tabs-items v-model="codeSelectedTable">

              <v-tab-item key="前台代码">
                <gh-code-editor :height="600" ref="codePage" title="前台代码编辑" :show-actions="false"
                  v-model="model.PageCode"
                  :options="{readOnly: false,autoIndent:true,automaticLayout: true,language:'javascript'}" @submit=''
                  @cancel=''>
                  <template #title>
                    <div></div>
                  </template>
                </gh-code-editor>
              </v-tab-item>
              <v-tab-item key="后台代码">
                <gh-code-editor :height="600" title="后台代码编辑" :show-actions="false" v-model="model.ServiceCode"
                  :options="{readOnly: false,autoIndent:true,automaticLayout: true,language:'python'}" @submit=''
                  @cancel='' ref="codeService">
                  <template #title>
                    <div></div>
                  </template>
                </gh-code-editor>
              </v-tab-item>
              <!-- <v-tab-item key="模板参数" v-show="model.Type==='模板'">
                <gh-code-editor title="" :show-actions="false" v-model="model.arguments" :height="600"
                  :options="{readOnly: false,autoIndent:true,automaticLayout: true,language:'json'}">
                </gh-code-editor>
              </v-tab-item> -->
            </v-tabs-items>
          </v-tabs>
        </v-layout>



      </v-container>


    </template>

  </gh-table-page>


</template>

<style scoped>

</style>

<script>
  import Page from "./page.ts";
  export default Page;
</script>